export default __webpack_public_path__ + "static/media/blog-img242.8aaf63b0.jpg";